import { render } from "./V12Style.vue?vue&type=template&id=b0452dc8&scoped=true"
import script from "./V12Style.vue?vue&type=script&lang=js"
export * from "./V12Style.vue?vue&type=script&lang=js"

import "./V12Style.vue?vue&type=style&index=0&id=b0452dc8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0452dc8"]])

export default __exports__